//Change navigation in header on scroll
function init() {
  window.addEventListener('scroll', function (e) {
    var distanceY = window.pageYOffset || document.documentElement.scrollTop,
      shrinkOn = 300;

    if (distanceY > shrinkOn) {
      $('header, #nav, #search').addClass("smaller");
    } else {
      if ($('header').hasClass("smaller")) {
        $('header, #nav, #search').removeClass("smaller");
      }
    }
  });

  window.addEventListener('scroll', function (e) {
    var distanceY = window.pageYOffset || document.documentElement.scrollTop,
      shrinkOn = 50;

    if (distanceY > shrinkOn) {
      $('#nav').addClass("kete-nav-scroll");
    } else {
      if ($('#nav').hasClass("kete-nav-scroll")) {
        $('#nav').removeClass("kete-nav-scroll");
      }
    }
  });
}
window.onload = init();



// WEBPACK FOOTER //
// ./src/js/headerSizeChange.js